import React from 'react';
import Index from '../components/index/Index';
import App from '../components/shared/App';

export default ({location}) => (
  <App location={location}>
    <Index />
  </App>
);
